import SliderNumeric from "./Slider/numeric/SliderNumeric";

const s = require('underscore.string');
import ICustomFormSettings from "./ICustomFormSettings";
import ICustomForm from "./ICustomForm";

import RadioListDefault from "./RadioList/default/RadioListDefault";
import PageLanding from "./Page/langing/PageLanding";
import DateTimeDate from "./DateTime/date/DateTimeDate";
import MinigameBalloon from "./Minigame/balloon/MinigameBalloon";
import NumberDefault from "./Number/default/NumberDefault";
import TextDefault from "./Text/default/TextDefault";
import HubDefault from "./Hub/default/HubDefault";
import HubImages from "./Hub/images/HubImages";
import CheckboxListDefault from "./CheckboxList/default/CheckboxListDefault";
import BatteryDefault from "./Battery/default/BatteryDefault";
import BatteryHappySadDK from "./Battery/happySadDK/BatteryHappySadDK";
import BatteryYesNoDK from "./Battery/yesNoDK/BatteryYesNoDK";
import RTMDefault from "./RTM/default/RTMDefault";
import RTMGuide from "./RTM/guide/RTMGuide";
import Stars5 from "./Stars/5/Stars5";
import CheckboxListImages from "./CheckboxList/images/CheckboxListImages";
import RadioListImages from "./RadioList/images/RadioListImages";
import NumberAge from "./Number/age/NumberAge";
import UploadPhotos from "./Upload/photos/UploadPhotos";
import DragDropSorting from "./DragDrop/sorting/DragDropSorting";
import Stars5half from "./Stars/5half/Stars5half";
import Stars10 from "./Stars/10/Stars10";
import SliderText from "./Slider/text/SliderText";
import SliderMultiple from "./Slider/multiple/SliderMultiple";
import StarsMultiple from "./Stars/multiple/StarsMultiple";
import NpsDefault from "./Nps/default/NpsDefault";
import General from "./General/General";
import BatteryNumericScale from "./Battery/numericScale/BatteryNumericScale";
import ImageHighlighterComment from "./ImageHighlighter/comment/ImageHighlighterComment";
import NpsColor from "./Nps/color/NpsColor";
import TextSpeechToText from "./Text/speachToText/TextSpeechToText";
import CalendarPicker from "./Calendar/picker/CalendarPicker";
import CheckboxListTiles from "./CheckboxList/tiles/CheckboxListTiles";
import TextHighlighterComment from "./TextHighlighter/comment/TextHighlighterComment";
import LocationGet from "./Location/get/LocationGet";
import DateTimeTime from "./DateTime/time/DateTimeTime";
import RadioListEmotionSignature from "./RadioList/emotionSignature/RadioListEmotionSignature";
import NumberRange from "./Number/range/NumberRange";
import RadioListSelectSimple from "./RadioList/selectSimple/RadioListSelectSimple";
import MapPoint from "./Map/point/MapPoint";
import MapTescomct from "./Map/tescomct/MapTescomct";
import PlayerAudio from "./Player/audio/PlayerAudio";
import PlayerTest from "./Player/test/PlayerTest";
import TextSuggestion from "./Text/suggestion/TextSuggestion";
import ReportPdf from "./Report/pdf/ReportPdf";
import TextTree from "./Text/tree/TextTree";
import UXTree from "./UX/tree/UXTree";
import RecordImages from "./Record/images/RecordImages";
import UploadFiles from "./Upload/files/UploadFiles";
import UploadDocuments from "./Upload/documents/UploadDocuments";
import BatteryImages from "./Battery/images/BatteryImages";
import {ScaleDefault} from "./Scale/default/ScaleDefault";
import MapPin from "./Map/pin/MapPin";
import KandidatiDefault from "./Kandidati/default/KandidatiDefault";
import KandidatiFinale from "./Kandidati/finale/KandidatiFinale";
import KandidatiUcast from "./Kandidati/ucast/KandidatiUcast";
import PageZero from "./Page/zero/PageZero";
import DragDropImages from "./DragDrop/images/DragDropImages";
import MaxDiffDefault from "./MaxDiff/default/MaxDiffDefault";
import MaxDiffDragdrop from "./MaxDiff/dragdrop/MaxDiffDragdrop";
import PriceTest from "./PriceTest/PriceTest";
import DragDropChart from "./DragDrop/chart/DragDropChart";
import CarouselDefault from "./Carousel/default/CarouselDefault";
import PriceTestPausal from "./PriceTest/PriceTestPausal";
import PriceTestDan1 from "./PriceTest/PriceTestDan1";
import PriceTestDan2 from "./PriceTest/PriceTestDan2";
import PriceTestEvidence from "./PriceTest/PriceTestEvidence";
import TreeLeaves from "./Tree/leaves/TreeLeaves";
import SliderNumericLabeled from "./Slider/numericLabeled/SliderNumericLabeled";
import ChaptersDefault from "./Chapters/default/ChaptersDefault";

export default class CustomFormFactory {

    /**
     * Find customForm-* in form class
     */
    public static parseFormType(formType: string): string {
        const classes = formType.split(' ');
        for (const formClass of classes) {
            if (s(formClass).startsWith('customForm-')) {
                return formClass.substr(11);
            }
        }
        return '';
    }

    public static create(formType: string, options: ICustomFormSettings): ICustomForm {

        switch (this.parseFormType(formType)) {

            case "Battery-default": return new BatteryDefault(options);
            case "Battery-happySadDK": return new BatteryHappySadDK(options);
            case "Battery-images": return new BatteryImages(options);
            case "Battery-numericScale": return new BatteryNumericScale(options);
            case "Battery-yesNoDK": return new BatteryYesNoDK(options);

            case "Calendar-picker": return new CalendarPicker(options);

            case "Carousel-default": return new CarouselDefault(options);

            case "Chapters-default": return new ChaptersDefault(options);

            case "CheckboxList-default": return new CheckboxListDefault(options);
            case "CheckboxList-images": return new CheckboxListImages(options);
            case "CheckboxList-tiles": return new CheckboxListTiles(options);

            case "DateTime-date": return new DateTimeDate(options);
            case "DateTime-time": return new DateTimeTime(options);

            case "DragDrop-chart": return new DragDropChart(options);
            case "DragDrop-sorting": return new DragDropSorting(options);
            case "DragDrop-images": return new DragDropImages(options);

            case "General": return new General(options);

            case "Hub-default": return new HubDefault(options);
            case "Hub-images": return new HubImages(options);

            case "ImageHighlighter-comment": return new ImageHighlighterComment(options);

            case "kandidati": return new KandidatiDefault(options);
            case "kandidati-finale": return new KandidatiFinale(options);
            case "kandidati-ucast": return new KandidatiUcast(options);

            case "LandingPage-default": return new PageLanding(options); // deprecated form class name

            case "Location-get": return new LocationGet(options);

            case "Map-pin": return new MapPin(options);
            case "Map-point": return new MapPoint(options);
            case "Map-tescomct": return new MapTescomct(options);

            case "MaxDiff-default": return new MaxDiffDefault(options);
            case "MaxDiff-dragdrop": return new MaxDiffDragdrop(options);

            case "Minigame-balloon": return new MinigameBalloon(options);

            case "Number-default": return new NumberDefault(options);
            case "Number-age": return new NumberAge(options);
            case "Number-range": return new NumberRange(options);

            case "NPS-color": return new NpsColor(options);
            case "NPS-default": return new NpsDefault(options);

            case "Page-landing": return new PageLanding(options);
            case "Page-zero": return new PageZero(options);

            case "Player-audio": return new PlayerAudio(options);
            case "Player-test": return new PlayerTest(options);

            case "PriceTest": return new PriceTest(options);
            case "PriceTest-pausal": return new PriceTestPausal(options);
            case "PriceTest-dan1": return new PriceTestDan1(options);
            case "PriceTest-dan2": return new PriceTestDan2(options);
            case "PriceTest-evidence": return new PriceTestEvidence(options);

            case "RadioList-default": return new RadioListDefault(options);
            case "RadioList-emotionSignature": return new RadioListEmotionSignature(options);
            case "RadioList-images": return new RadioListImages(options);
            case "RadioList-selectSimple": return new RadioListSelectSimple(options);

            case "Record-images": return new RecordImages(options);

            case "Report-pdf": return new ReportPdf(options);

            case "RTM-default": return new RTMDefault(options);
            case "RTM-guide": return new RTMGuide(options);

            case "Scale-default": return new ScaleDefault(options);

            case "Slider-numeric": return new SliderNumeric(options);
            case "Slider-numericLabeled": return new SliderNumericLabeled(options);
            case "Slider-text": return new SliderText(options);
            case "Slider-multiple": return new SliderMultiple(options);

            case "Stars-5": return new Stars5(options);
            case "Stars-5half": return new Stars5half(options);
            case "Stars-10": return new Stars10(options);
            case "Stars-multiple": return new StarsMultiple(options);

            case "Text-default": return new TextDefault(options);
            case "Text-speechToText": return new TextSpeechToText(options);
            case "Text-suggestion": return new TextSuggestion(options);
            case "Text-tree": return new TextTree(options);

            case "TextHighlighter-comment": return new TextHighlighterComment(options);

            case "Tree-leaves": return new TreeLeaves(options);

            case "Upload-documents": return new UploadDocuments(options);
            case "Upload-files": return new UploadFiles(options);
            case "Upload-photos": return new UploadPhotos(options);

            case "UX-tree": return new UXTree(options)

            default: {
                console.warn('Form typing is case sensitive. For example: "customForm-RadioList-default", you wrote "'+formType+'".');
                throw Error("CustomFormFactory: Cannot create form of type "+formType+". This type does not exist. Fallback to SE2 form rendering.");
            }
        }
    }

}
